import { t } from 'i18next';
import { useAuthContext } from 'services/authentication/AuthenticationContext';

/*
 * contactTypeOptions.ts
 * The contact types which only exist inside the admin environment,
 * such as a cancelled customer. Regular users never see them as an
 * option, a filter or a list entry.
 */

// The contact types reserved for the admin environment
export const ADMIN_ONLY_CONTACT_TYPES = ['cancelled'];

// Returns the admin only contact types when the user works in the admin environment
export const useAdminOnlyContactTypes = (): string[] => {
    const { environmentType } = useAuthContext();
    return environmentType === 'admin' ? ADMIN_ONLY_CONTACT_TYPES : [];
};

// Builds the dropdown options of the admin only contact types with the given translation prefix
export const buildAdminOnlyContactTypeOptions = (adminOnlyTypes: string[], translationPrefix: string) => {
    return adminOnlyTypes.map(contactType => ({ value: contactType, name: `${translationPrefix}.${contactType}` }));
};

// Returns the suffix shown behind a blocked or cancelled contact in a contact selection, or null
export const getContactStatusSuffix = (option: any, contactType?: string): string | null => {
    if (option?.blocked) return t('contact.general.blocked_suffix');
    if ((contactType ?? option?.contact_type) === 'cancelled') return t('contact.general.cancelled_suffix');
    return null;
};

// Returns the customer number between brackets behind a contact name, or null without a number
export const getContactNumberSuffix = (contact: any): string | null => {
    return contact?.number ? `(${contact.number})` : null;
};
